"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionPopup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _SubscribeForm = _interopRequireDefault(require("../../../build/components/SubscribeForm"));
var _DialogTitle = _interopRequireDefault(require("../DialogTitle"));
var _dateTime = require("../../utils/dateTime");
var _hooks = require("../../hooks");
var _apiKeys = require("../../state/entities/apiKeys");
var _internalAccount = require("../../api/accessors/internalAccount");
var _style = _interopRequireDefault(require("../../../../account/src/components/Popup/style"));
var _WarningContent = _interopRequireDefault(require("./WarningContent"));
var _usePopupOpenState = require("../../../../account/src/components/Popup/usePopupOpenState");
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _ErrorBoundary = require("../ErrorBoundary");
var _eventEmitter = require("../../utils/eventEmitter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HIDDEN_MODE = 'HIDDEN_MODE';
const WARNING_MODE = 'WARNING_MODE';
const SUBSCRIPTION_MODE = 'SUBSCRIPTION_MODE';
const daysTilExpireThreshold = 30;
const SubscriptionPopup = _ref => {
  let {
    account: accountWithStripe,
    fetchingAccount,
    fetchingAccountError,
    onCancel,
    ...props
  } = _ref;
  const {
    internalAccount: account,
    stripeAccount: customer
  } = accountWithStripe || {};
  const intl = (0, _hooks.useIntl)();
  const classes = (0, _style.default)(props);
  const isLoggedIn = (0, _reactRedux.useSelector)(_apiKeys.apiKeysSelectors.isLoggedIn);
  const popupSeen = !!Number((0, _reactRedux.useSelector)(_apiKeys.apiKeysSelectors.popupSeen));
  const {
    popupOpen,
    openPopup,
    closePopup: onDialogClose
  } = (0, _usePopupOpenState.usePopupOpenState)(false);
  const [forceSubscriptionMode, setForceSubscriptionMode] = (0, _react.useState)(false);
  const openSubscriptionPopup = () => {
    setForceSubscriptionMode(true);
    openPopup();
  };
  const handleClose = () => {
    onCancel();
    onDialogClose();
  };
  const getPopupMode = () => {
    if (forceSubscriptionMode) {
      return SUBSCRIPTION_MODE;
    }
    if (!isLoggedIn || popupSeen || fetchingAccountError || (0, _internalAccount.hasActiveSubscription)(account) || !(0, _internalAccount.getExpiresAt)(account) || (0, _internalAccount.getIsChargeable)(account) === false) {
      return HIDDEN_MODE;
    }
    if ((0, _dateTime.getDateDiffFromNow)((0, _internalAccount.getExpiresAt)(account)) <= 45 && !popupSeen) {
      return SUBSCRIPTION_MODE;
    }
    if ((0, _internalAccount.hasNoSubscription)(account, customer)) {
      const expiryDate = Date.parse((0, _internalAccount.getExpiresAt)(account));
      return expiryDate && Date.now() + daysTilExpireThreshold * 24 * 60 * 60 * 1000 > expiryDate ? SUBSCRIPTION_MODE : HIDDEN_MODE;
    }
    if ((0, _internalAccount.hasPastDueSubscription)(account) || (0, _internalAccount.hasIncompleteSubscription)(account)) return WARNING_MODE;
    return HIDDEN_MODE;
  };
  const onDataFetched = () => {
    if (getPopupMode() !== HIDDEN_MODE) {
      openPopup();
    }
  };
  (0, _react.useEffect)(() => {
    if (account && !fetchingAccount) {
      onDataFetched();
    }
  }, [account, fetchingAccount]);
  (0, _react.useEffect)(() => {
    _eventEmitter.eventEmitter.on(_eventEmitter.OPEN_SUBSCRIPTION_POPUP, openSubscriptionPopup);
    return () => {
      _eventEmitter.eventEmitter.removeListener(_eventEmitter.OPEN_SUBSCRIPTION_POPUP, openSubscriptionPopup);
    };
  }, []);
  return popupOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.overlay
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.dialog
  }, getPopupMode() === WARNING_MODE && /*#__PURE__*/_react.default.createElement(_WarningContent.default, {
    account: account,
    onClose: onDialogClose
  }), getPopupMode() === SUBSCRIPTION_MODE && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    onClose: handleClose
  }), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, /*#__PURE__*/_react.default.createElement(_ErrorBoundary.ErrorBoundary, {
    renderFallback: error => /*#__PURE__*/_react.default.createElement(_core.Box, {
      pt: 3,
      pb: 2
    }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
      text: error.message || intl.formatMessage({
        id: 'something_went_wrong_please_contact_support'
      })
    }))
  }, /*#__PURE__*/_react.default.createElement(_SubscribeForm.default, {
    customer: customer,
    onClose: handleClose,
    showTitle: false,
    expiresAt: (0, _internalAccount.getExpiresAt)(account)
  }))))));
};
exports.SubscriptionPopup = SubscriptionPopup;